import React from 'react';
import { SvgIcon } from '../SvgIcon/SvgIcon.esm.js';

const CircleCheckIcon = ({ ...props }) => {
    return (React.createElement(SvgIcon, { ...props, viewBox: "0 0 16 16" },
        React.createElement("path", { d: "M14.5754 4.0896L14.1399 3.49365L6.79223 11.0734C6.61852 11.2579 6.32507 11.2572 6.15215 11.072L2.78569 7.58722C2.62041 7.41016 2.62993 7.13263 2.80693 6.96729L3.44835 6.36835C3.62547 6.20294 3.90312 6.21247 4.06847 6.38965L6.47747 8.8487L12.965 2.18231C11.6784 1.1239 9.97522 0.5 8 0.5C3.59863 0.5 0.5 3.54865 0.5 7.75385V8.2461C0.5 12.4502 3.59863 15.5 8 15.5C12.4014 15.5 15.5 12.4513 15.5 8.2461V7.75385C15.5 6.38776 15.1681 5.14686 14.5754 4.0896Z" })));
};

export { CircleCheckIcon };
//# sourceMappingURL=CircleCheckIcon.esm.js.map
